import classNames from 'classnames'

import './styles.css'


export default function Logo(props) {
  const { className } = props;

  const cx = classNames(['logo', className]);

  return (
    <div className={cx}>
      <img className="logoImg" src="/img/logo3000_w.png" alt="logo" />
      <div className="logoTitle">Территория 3000</div>
    </div>
  );
}
